/**
 * CalendarModification_PlanningEventEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90004
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { CalendarModificationEntity } from "../CalendarModificationEntity";
import { PlanningEventEntity } from "../PlanningEventEntity";
import { CalendarModification_PlanningEventEntity } from "../CalendarModification_PlanningEventEntity";
declare global {
    interface EntityTypeMap {
        CalendarModification_PlanningEvent: CalendarModification_PlanningEventEntity;
    }
}
export abstract class CalendarModification_PlanningEventGeneratedEntity extends BaseEntity {
    public abstract relationId: string;
    public abstract templateId: string | null;
    public abstract baselineEndDate: Date | null;
    public abstract calendarModification: CalendarModificationEntity;
    public abstract planningEvent: PlanningEventEntity;
}
